import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { withServerSideTranslations } from '@/lib/hoc/withServerSideTranslations'
import useClientRedirect from '@/lib/hooks/routing/useRedirect'
import useGlobalStore from '@/store/useGlobalStore'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'

export const getServerSideProps = withServerSideTranslations()

const ReferralWithProductRedirectPage = () => {
  const router = useRouter()
  const { clientRedirect } = useClientRedirect()
  const { setUser } = useGlobalStore()

  useEffect(() => {
    const referralCode = router.query.referralCode as string | undefined
    if (referralCode !== undefined) {
      const isNumeric = /^\d+$/.test(referralCode || '')
      mixpanelService.registerSuperProperties({
        ...(isNumeric
          ? { referral_id: referralCode }
          : { referral_code: referralCode }),
      })
      setUser({ refID: referralCode })
      ;(async () => {
        await clientRedirect.to({ path: `/product/${router.query.product}` })
      })().catch(() => {})
    }
  }, [])
}

export default ReferralWithProductRedirectPage
